import { BaseModel, RecursivePartial } from '@models/base';
import { SiteConfigAuth } from './site-config-auth';
import { SiteConfigButton } from './site-config-button';
import { SiteConfigCalendar } from './site-config-calendar';
import { SiteConfigChat } from './site-config-chat';
import { SiteConfigTheme } from './site-config-theme';

export class SiteConfig extends BaseModel {
    mode?: 'button' | 'form';
    title: string = '';

    theme!: SiteConfigTheme;
    button!: SiteConfigButton;
    auth!: SiteConfigAuth;
    calendar!: SiteConfigCalendar;
    chat!: SiteConfigChat;

    constructor(json?: RecursivePartial<SiteConfig>) {
        super(json);
        this.parseSiteConfig(json || {});
    }

    parse(json: RecursivePartial<SiteConfig>): SiteConfig {
        super.parse(json);
        this.parseSiteConfig(json);
        return this;
    }

    private parseSiteConfig(json: RecursivePartial<SiteConfig>): void {
        SiteConfig.assignFields<SiteConfig>(this, json, ['mode', 'title']);
        SiteConfig.assignClassFields<SiteConfig>(this, json, {
            theme: SiteConfigTheme,
            button: SiteConfigButton,
            auth: SiteConfigAuth,
            calendar: SiteConfigCalendar,
            chat: SiteConfigChat,
        });
    }
}

export const SITE_CONFIG_DEFAULT: Partial<SiteConfig> = {
    mode: 'button',
    title: 'Vizorro.ru',

    theme: {
        name: 'default',
        title: 'Vizorro.ru',
        bgColor: '#ffffff',
        textColor: '#404040',
        primaryColor: '#00695c',
        accentColor: '#ffc107',
    },

    button: {
        img: 'data:image/svg+xml;base64,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',
        text1: 'посмотреть',
        text2: 'товар',
    },

    auth: {
        nameField: {
            id: '__name',
            show: true,
            title: 'Имя',
            placeholder: 'Елисей Никонорович',
            constraints: {
                required: true,
                min: 2,
                max: 50,
                errors: {
                    required: 'Пожалуйста, укажите ваше имя',
                    min: 'Имя не может быть менее 2 символов',
                    max: 'Имя не должно быть более 50 символов',
                }
            }
        },
        emailField: {
            id: '__email',
            show: true,
            title: 'E-mail',
            placeholder: 'elisey@company.ru',
            constraints: {
                required: true,
                min: 6,
                max: 50,
                regexp: '.+@[a-zA-Z][a-zA-Z0-9-]*[a-zA-Z0-9]+\\.[a-zA-Z]{2,}',
                errors: {
                    required: 'Пожалуйста, укажите ваш E-mail',
                    min: 'E-mail не может быть менее 6 символов',
                    max: 'E-mail не должен быть более 50 символов',
                    regexp: 'Неверный формат E-mail'
                }
            }
        },
        phoneField: {
            id: '__phone',
            show: true,
            title: 'Телефон',
            placeholder: '+7 (111) 222-33-44',
            constraints: {
                regexp: '^\\+\\d{11}|^\\d{5,}',
                regexpClearString: '\\s|\\(|\\)|-',
                errors: {
                    regexp: 'Неверный формат номера'
                }
            }
        },
        messageField: {
            id: '__message',
            show: true,
            title: 'Сообщение',
            placeholder: 'Ваш вопрос или предложение',
            constraints: {
                min: 10,
                max: 2000,
                errors: {
                    min: 'Сообщение не может быть менее 10 символов',
                    max: 'Сообщение не должно быть более 2000 символов',
                }
            }
        },

        captcha: {
            show: true,
            type: 'yandex',
            data: {
                invisible: true
            }
        },

        chatButton: {
            show: false,
            title: 'Начать чат'
        },
        videoButton: {
            show: true,
            title: 'Запросить видеовстречу'
        },

        verifyEmail: true,
        verifyEmailTitle: 'Введите код из письма отправленного вам.',
        verifyCodeButtonTitle: 'Проверить код',

    },

    calendar: {
        title: 'Когда вы хотите посмотреть товар?',
        // showNow: true,
        windowSize: 10,
        startOffset: 120,
        confirmMessage: 'Запросить видеовстречу',
        finishedMessage: 'Видеовстреча была успешно зарезервирована. Пожалуйста следуйте инструкциям высланным на ваш Email.',
        sendButton: {
            show: true,
            title: 'Отправить запрос'
        },
        videoButton: {
            show: true,
            title: 'Подтвердить запись'
        },
    },

    chat : {
        welcomeMessage: 'Пожалуйста ожидайте, наши консультанты сейчас дерутся за право ответить вам.',
        finishedMessage: 'Сеанс завершен.',
    }
} as any;

export const SITE_CONFIG_FORCE: Partial<SiteConfig> = {
    auth: {
        nameField: {
            show: true,
            constraints: {
                required: true,
            }
        },
        emailField: {
            show: true,
            constraints: {
                required: true,
            }
        },
        captcha: {
            show: true,
        },
        chatButton: {
            show: false,
        },
    },
} as any;
